import { create } from 'zustand';
const SESSION_DURATION = 60 * 60 * 1000 //session duration 1 hour in miliseconds
export const useAuthStore = create((set) => ({
  auth: {
    username: '',
    active: false,
    role: null,
    token:null
  },
  setUsername: (name) => set((state) => ({
     auth: { ...state.auth, username: name } 
    })),
  setLoginStatus: (status) =>
    set((state) => ({ 
      auth: { ...state.auth, isLoggedIn: status } 
    })),
  setUserDetails: ({ username, profile, firstName, email,role,token,country }) =>{
    const userData={
       
        username, 
        profile, 
        firstName, 
        email, 
        role:role??null,
        isLoggedIn: true,
        token, 
        country
    };
     console.log("Setting user details:", userData);
    //save session in localstorage with timestamp
    const session={
      user:userData,
      timestamp:Date.now(),
    }
    localStorage.setItem("session", JSON.stringify(session));
    set(()=>({auth:userData}));
  },
  logout:()=>{
    localStorage.removeItem("session");
    localStorage.removeItem("token");
    set(()=>({
      auth:{
      username:"",
      email:"",
      profile:null,
      firstName:"",
      role:null,
      active:false,
      isLoggedIn:false,
      token:null,
      country:""

      }
    }));
  },

  //load user from localStorage on appstart
  loadUserFromStorage:()=>{
    const session=JSON.parse(localStorage.getItem("session"));
    if(!session) return;
    const {user,timestamp}=session;
    if(Date.now()-timestamp>SESSION_DURATION){
      localStorage.removeItem("session");
      return;
    }set(()=>({
      auth:{
        ...user,
        isLoggedIn:true
      },
    }));
  },
    
}))
